import { baseApi } from '@shared/api'

export const orderDetailsApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchOrderDetails: builder.mutation<any, { orderNo: string }>({
        query: ({ orderNo }) => ({
          url: '/ib/order/card/salary/details',
          data: { orderNo },
          method: 'POST',
          skipGlobalError: true,
        }),
      }),
    }
  },
})

export const { useFetchOrderDetailsMutation } = orderDetailsApi
